const GRADES = ['A+', 'A', 'B+', 'B', 'C', 'D', 'F'];

/**
 * Computes the internet score for a device from a device_data_aggregate.aggregate object.
 * Grade: string - the grade of the internet score
 * Average Delay: number - the average delay of the internet score in seconds.
 * Data Coverage: number - the data coverage of the internet score 0.0 to 1.0.
 * Returns null when there is no data to score.
 *
 * @param {object|null|undefined} aggregate - device_data_aggregate.aggregate
 * @returns {{ grade: string, averageDelay: number, dataCoverage: number } | null}
 */
export function computeInternetScore(aggregate) {
  const dataCount = aggregate?.count;
  if (!dataCount || dataCount === 0) return null;

  const duration = aggregate?.sum?.duration || 0;
  const dataCoverage = Math.min(1, Math.max(0, duration / (24 * 60 * 60)));
  const averageDelay = (aggregate.sum.created_at - aggregate.sum.ended_at) / dataCount;

  let delayScore = 0;
  if (averageDelay >= 60 * 60) delayScore = 3;
  else if (averageDelay >= 15 * 60) delayScore = 2;
  else if (averageDelay >= 60) delayScore = 1;

  let dataCoverageScore = 0;
  if (dataCoverage <= 0.85) dataCoverageScore = 3;
  else if (dataCoverage <= 0.9) dataCoverageScore = 2;
  else if (dataCoverage <= 0.95) dataCoverageScore = 1;

  return {
    grade: GRADES[Math.min(delayScore + dataCoverageScore, GRADES.length - 1)],
    averageDelay,
    dataCoverage,
  };
}
